import React from 'react';
import { FormattedMessage } from 'react-intl';
import heroImage from '../Images/landing-finding-banner.png';
import css from './Sections.module.css';

function HeroSection() {
  return (
    <div className={css.heroSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.heroImg}>
          <img src={heroImage} alt="land finding banner" />
        </div>
        <div className={css.heroInfo}>
          <h2>
            <FormattedMessage id="LandFindingPage.HeroSection.title" />
          </h2>
          <p>
            <FormattedMessage id="LandFindingPage.HeroSection.description" />
          </p>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
